import './bootstrap';

/**
 * Chart Js
 */
import Chart from 'chart.js/auto';
window.Chart = Chart;

import * as dayjs from 'dayjs';
import * as duration from 'dayjs/plugin/duration';
import * as relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(duration);
dayjs.extend(relativeTime);

window.dayjs = dayjs;
